export default __webpack_public_path__ + "static/media/conversation.0d5b6dbf.svg";